import React, { useState, useEffect } from 'react';
import Wrapper from '../../../Main/Universal/Wrapper';
import { postAPI, postAPIForm } from '../../../../app/api';
import editIcon from "../../../../theme/assets/images/icon/edit-icon.svg"
import deleteIcon from "../../../../theme/assets/images/icon/delete-icon.svg"
import Swal from 'sweetalert2';

export default function NewsEventsSection() {
    const [newsItems, setNewsItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({
        title: '',
        date: '',
        description: '',
        image: null,
        is_published: 0,
        status: 1
    });

    // Fetch all news items
    useEffect(() => {
        fetchNews();
    }, []);

    const fetchNews = async () => {
        try {
            setLoading(true);
            const response = await postAPI('news/list', {});
            if (response?.status === 1) {
                setNewsItems(response?.data || []);
            }
        } catch (error) {
            console.error('Error fetching news:', error);
            Swal.fire('Error', 'Failed to fetch news items', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Handle form changes
    const handleChange = (e) => {
        const { name, value, files, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (checked ? 1 : 0) : (files ? files[0] : value)
        }));
    };

    // Add/Update news item
    const handleAddNews = async (e) => {
        e.preventDefault();
        try {
            if (!formData.title || !formData.description || !formData.date) {
                Swal.fire('Validation', 'Please fill all required fields', 'warning');
                return;
            }

            let submitData = {
                title: formData.title,
                date: formData.date,
                description: formData.description,
                is_published: formData.is_published,
                status: formData.status
            };

            if (editingId) submitData.id = editingId;

            // If image exists, upload it
            if (formData.image && typeof formData.image !== 'string') {
                const fileFormData = new FormData();
                fileFormData.append('baseDir', 'news');
                fileFormData.append('filename', 'news_image');
                fileFormData.append('original_file', formData.image);

                const uploadResponse = await postAPIForm('file/uploadFile', fileFormData);
                if (uploadResponse?.status === 1) {
                    submitData.image = uploadResponse?.filepath;
                }
            }

            const response = await postAPI('news/create', submitData);
            if (response?.status === 1) {
                Swal.fire('Success', 'News item saved successfully', 'success');
                resetForm();
                fetchNews();
            } else {
                Swal.fire('Error', response?.msg || 'Failed to save news item', 'error');
            }
        } catch (error) {
            console.error('Error saving news:', error);
            Swal.fire('Error', error.message || 'Failed to save news item', 'error');
        }
    };

    // Delete news item
    const handleDeleteNews = async (id) => {
        const result = await Swal.fire({
            title: 'Confirm Delete',
            text: 'Are you sure you want to delete this news item?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                const response = await postAPI('news/delete', { id });
                if (response?.status === 1) {
                    Swal.fire('Success', 'News item deleted successfully', 'success');
                    fetchNews();
                }
            } catch (error) {
                Swal.fire('Error', 'Failed to delete news item', 'error');
            }
        }
    };

    // Toggle publish
    const handleTogglePublish = async (id, isPublished) => {
        try {
            const endpoint = isPublished ? 'news/unpublish' : 'news/publish';
            const response = await postAPI(endpoint, { id });
            if (response?.status === 1) {
                Swal.fire('Success', `News item ${isPublished ? 'unpublished' : 'published'} successfully`, 'success');
                fetchNews();
            }
        } catch (error) {
            Swal.fire('Error', 'Failed to update publish status', 'error');
        }
    };

    const resetForm = () => {
        setFormData({
            title: '',
            date: '',
            description: '',
            image: null,
            is_published: 0,
            status: 1
        });
        setShowForm(false);
        setEditingId(null);
    };

    const handleToggleForm = () => {
        if (showForm) {
            setShowForm(false);
            resetForm();
        } else {
            setEditingId(null);
            setFormData({
                title: '',
                date: '',
                description: '',
                image: null,
                is_published: 0,
                status: 1
            });
            setShowForm(true);
        }
    };

    const handleEditNews = (item) => {
        setFormData({
            title: item.title || '',
            date: item.date || '',
            description: item.description || '',
            image: item.image || null,
            is_published: item.is_published || 0,
            status: item.status || 1
        });
        setEditingId(item.id);
        setShowForm(true);
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row mb-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center">
                            <h3 className="mb-0">News & Events Management</h3>
                            {/* <button 
                                    className="btn btn-primary"
                                    onClick={handleToggleForm}
                                >
                                    {showForm ? 'Cancel' : 'Add New News'}
                                </button> */}
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setEditingId(null);
                                    resetForm();
                                    document.getElementById("openNewsModalBtn").click();
                                }}
                            >
                                {showForm ? 'Cancel' : 'Add New News'}
                            </button>
                        </div>
                    </div>
                </div>
                <button
                    id="openNewsModalBtn"
                    className="d-none"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#newsModal"
                ></button>



                {/* {showForm && (
                        <div className="card mb-4">
                            <div className="card-body">
                                <h5 className="card-title">{editingId ? 'Edit News Item' : 'Add New News Item'}</h5>
                                <form onSubmit={handleAddNews}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Title *</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                placeholder="e.g., Independence Day Cultural Evening"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Date *</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="date"
                                                value={formData.date}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Status</label>
                                            <select
                                                className="form-control"
                                                name="status"
                                                value={formData.status}
                                                onChange={handleChange}
                                            >
                                                <option value={1}>Active</option>
                                                <option value={0}>Inactive</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">
                                                <input
                                                    type="checkbox"
                                                    name="is_published"
                                                    checked={formData.is_published === 1}
                                                    onChange={handleChange}
                                                />
                                                {' '}Publish
                                            </label>
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="form-label">Description *</label>
                                            <textarea
                                                className="form-control"
                                                name="description"
                                                value={formData.description}
                                                onChange={handleChange}
                                                rows="4"
                                                placeholder="Enter news description"
                                                required
                                            ></textarea>
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="form-label">News Image</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                name="image"
                                                onChange={handleChange}
                                                accept="image/*"
                                            />
                                            {formData.image && typeof formData.image === 'string' && (
                                                <small className="text-muted">Current: {formData.image}</small>
                                            )}
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-success">
                                        {editingId ? 'Update' : 'Add'} News Item
                                    </button>
                                </form>
                            </div>
                        </div>
                    )} */}
                <div className="modal fade modal-white" id="newsModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-md modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {editingId ? "Edit News Item" : "Add New News Item"}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                ></button>
                            </div>

                            <div className="modal-body">
                                <form onSubmit={handleAddNews}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Title *</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                placeholder="e.g., Independence Day Cultural Evening"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Date *</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="date"
                                                value={formData.date}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Status</label>
                                            <select
                                                className="form-control"
                                                name="status"
                                                value={formData.status}
                                                onChange={handleChange}
                                            >
                                                <option value={1}>Active</option>
                                                <option value={0}>Inactive</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">
                                                <input
                                                    type="checkbox"
                                                    name="is_published"
                                                    checked={formData.is_published === 1}
                                                    onChange={handleChange}
                                                />
                                                {' '}Publish
                                            </label>
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="form-label">Description *</label>
                                            <textarea
                                                className="form-control"
                                                name="description"
                                                value={formData.description}
                                                onChange={handleChange}
                                                rows="4"
                                                placeholder="Enter news description"
                                                required
                                            ></textarea>
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="form-label">News Image</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                name="image"
                                                onChange={handleChange}
                                                accept="image/*"
                                            />
                                            {formData.image && typeof formData.image === 'string' && (
                                                <small className="text-muted">Current: {formData.image}</small>
                                            )}
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-success">
                                        {editingId ? 'Update' : 'Add'} News Item
                                    </button>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-striped table-hover cus-table">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Title</th>
                                            <th>Date</th>
                                            <th>Description</th>
                                            <th>Status</th>
                                            <th>Published</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {newsItems && newsItems.length > 0 ? (
                                            newsItems.map((item, index) => (
                                                <tr key={index}>
                                                    <td><strong>{item.title}</strong></td>
                                                    <td>{new Date(item.date).toLocaleDateString()}</td>
                                                    <td>{item.description?.substring(0, 40)}...</td>
                                                    <td>
                                                        <span className={`badge badge-${item.status === 1 ? 'success' : 'danger'}`}>
                                                            {item.status === 1 ? 'Active' : 'Inactive'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`badge badge-${item.is_published === 1 ? 'info' : 'secondary'}`}>
                                                            {item.is_published === 1 ? 'Published' : 'Draft'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <button
                                                            className="btn me-2 py-0 my-0 mx-0"
                                                            onClick={() => handleTogglePublish(item.id, item.is_published)}
                                                            title={item.is_published ? 'Unpublish' : 'Publish'}
                                                        >
                                                            {item.is_published ? 'Unpublish' : 'Publish'}
                                                        </button>
                                                        <button
                                                            className="btn me-2 py-0 my-0 mx-0"
                                                            onClick={() => handleEditNews(item)}
                                                        >
                                                            <img src={editIcon} />
                                                        </button>
                                                        <button
                                                            className="btn py-0 my-0 mx-0"
                                                            onClick={() => handleDeleteNews(item.id)}
                                                        >
                                                            <img src={deleteIcon} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center py-4">
                                                    No news items found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
